module.exports = __webpack_public_path__ + "letter-x.d70d44bbd17bccb8cdeb6b39e653210c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/letter-x.svg
// module id = 70
// module chunks = 0